import React from "react";
import { Autocomplete, Chip, CircularProgress, InputAdornment, TextField } from "@mui/material";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";
import ClientSearchOption from "./ClientSearchOption";
import {
  clientHasWhatsappPhone,
  formatClientDisplayPhone,
  pickClientWhatsappPhone,
} from "../../utils/phone";

/** Busca de clientes (igual à nova solicitação) só com quem tem celular/WhatsApp. */
export default function WhatsappGroupParticipantsPicker({
  value = [],
  onChange,
  options = [],
  loading = false,
  inputValue,
  onInputChange,
  disabled = false,
  label,
  placeholder,
  helperText,
  noOptionsText,
  noNameLabel = "Sem nome",
}) {
  const selected = Array.isArray(value) ? value : [];
  const selectable = (Array.isArray(options) ? options : []).filter(clientHasWhatsappPhone);

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      filterSelectedOptions
      disabled={disabled}
      options={selectable}
      value={selected}
      inputValue={inputValue}
      onInputChange={(event, next, reason) => {
        if (typeof onInputChange === "function") onInputChange(event, next, reason);
      }}
      onChange={(_, next) => {
        const picked = (Array.isArray(next) ? next : []).filter(clientHasWhatsappPhone);
        if (typeof onChange === "function") onChange(picked);
      }}
      getOptionLabel={(option) =>
        typeof option === "object" ? option?.name || option?.nome || "" : ""
      }
      isOptionEqualToValue={(a, b) => String(a?.id) === String(b?.id)}
      getOptionDisabled={(option) => !clientHasWhatsappPhone(option)}
      filterOptions={(opts) => opts.filter(clientHasWhatsappPhone)}
      loading={loading}
      noOptionsText={noOptionsText}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              {...tagProps}
              key={option.id || key}
              size="small"
              label={option.name || option.nome || noNameLabel}
            />
          );
        })
      }
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          <ClientSearchOption
            client={option}
            primary={option.name || option.nome}
            secondary={formatClientDisplayPhone(option) || pickClientWhatsappPhone(option)}
            fallbackPrimary={noNameLabel}
          />
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={selected.length ? "" : placeholder}
          helperText={helperText}
          size="small"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <PersonSearchRoundedIcon color="action" fontSize="small" />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} sx={{ mr: 1 }} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
